import httpClient from './httpClient'

const END_POINT = '/api/cursos'

const getCursoActual = async () => {
    return await httpClient.get(END_POINT, {
        "params": { "order[anio]": "desc", "pagination": "false" }
    });
}

export {

    getCursoActual

}